import React, {CheckBox} from 'react';
import {Link} from 'react-router-dom';
import {toastr} from 'react-redux-toastr';
import CustomList from '../common/CustomList';
import * as userActions from '../../actions/userActions';
import SortableHead from '../common/list/SortableHead';
import UserListRow from "./UserListRow";
import { injectIntl } from 'react-intl';
import {messages} from '../common/Translations';

// id for identification unassigning company from user
const NO_COMPANY = 'NO_COMPANY';

class UsersList extends React.Component {

    constructor(props) {
        super(props);
        this.onIsWebmasterChange = this.onIsWebmasterChange.bind(this);
        this.onCompanyChange     = this.onCompanyChange.bind(this);
    }

    onCompanyChange(e) {
        let companyId = e.target.value;
        if(!parseInt(companyId)) {
            if(companyId === NO_COMPANY) {
                companyId = null;
            }
            else {
                toastr.error(this.props.intl.formatMessage(messages.somethingWrong));
                return;
            }
        }

        this.props.changeCompany(companyId, e.target.getAttribute('data-user-id'));
    }

    onIsWebmasterChange(e) {
        let userId = e.target.getAttribute('data-user-id');
        let isWebmaster = e.target.checked;

        // I can't change value for myself
        if(this.props.user.id == userId) {
            e.target.checked = !e.target.checked;
            toastr.error(this.props.intl.formatMessage(messages.cannotChangeOwnValue));
            return false;
        }

        this.props.changeIsWebmaster(userId, isWebmaster);
    }

    render() {
        let {
            users,
            companies,
            onDelete,
            listId
        } = this.props;

        companies = companies.slice();
        companies.unshift({
            id: NO_COMPANY,
            name: this.props.intl.formatMessage(messages.selectCompany),
        });

        const companyOptions = companies.map(function (company, key) {
            if(!company.name) {
                company.name = this.props.intl.formatMessage(messages.noName);
            }

            return <option key={key} value={company.id}>{company.name}</option>
        });

        return (
            <div>
                <table className="table table-striped">
                    <SortableHead
                        listId={listId}
                        action={userActions.loadUsers}
                        columns={[
                            {
                                title: this.props.intl.formatMessage(messages.name),
                                name: 'name',
                            },
                            {
                                title: this.props.intl.formatMessage(messages.email),
                                name: 'email',
                            },
                            {
                                title: this.props.intl.formatMessage(messages.title),
                                name: 'workingTitle',
                            },
                            {
                                title: this.props.intl.formatMessage(messages.company),
                            },
                            {
                                title: this.props.intl.formatMessage(messages.webmaster),
                            },
                            {
                                title: this.props.intl.formatMessage(messages.actions),
                                className: 'text-right',
                            },
                        ]}
                    />
                    <tbody>
                    {
                        users.map(user => <UserListRow
                            key={user.id}
                            user={user}
                            companyOptions={companyOptions}
                            onCompanyChange={this.onCompanyChange}
                            onIsWebmasterChange={this.onIsWebmasterChange}
                            onDelete={onDelete}
                            listId={listId}
                        />)
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default injectIntl(UsersList);


// WEBPACK FOOTER //
// ./web/src/components/users/UsersList.jsx